import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=70fc0491&"
import script from "./AdminUsers.vue?vue&type=script&lang=js&"
export * from "./AdminUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports